<app-loading *ngIf="contentReady"></app-loading>

<section
  class="bb-page heroes-ticket-page"
  [class.rtl]="isAr"
  [attr.dir]="isAr ? 'rtl' : 'ltr'"
>
  <div class="bb-page-shell heroes-ticket-shell">

    <!-- Header -->
    <header class="heroes-mobile-hero">
      <div class="heroes-hero-copy">
        <span class="bb-eyebrow">
          {{ "delivery heroes" | transloco }}
        </span>

        <h2>
          {{ "delivery heroes" | transloco }}
        </h2>

        <p>
          {{ "Manage your delivery team" | transloco }}
        </p>
      </div>

      <div class="heroes-hero-counter" *ngIf="stockTotal">
        <strong>{{ stockTotal }}</strong>
        <span>{{ "total" | transloco }}</span>
      </div>
    </header>

    <!-- Top Actions -->
    <section class="heroes-top-actions">
      <button
        type="button"
        routerLink="/adddeliveryhero"
        class="bb-btn bb-btn-primary"
      >
        <i class="fa-solid fa-plus" aria-hidden="true"></i>
        {{ "new delivery hero" | transloco }}
      </button>

      <button
        type="button"
        routerLink="/deliveryfees"
        class="bb-btn bb-btn-secondary"
      >
        <i class="fa-solid fa-money-bill-wave" aria-hidden="true"></i>
        {{ "delivery fees" | transloco }}
      </button>

      <button
        type="button"
        routerLink="/herosmap"
        class="bb-btn bb-btn-secondary"
      >
        <i class="fa-solid fa-map-location-dot" aria-hidden="true"></i>
        {{ "maps" | transloco }}
      </button>

      <!-- Admin Warehouse Filter -->
      <!--
      <div class="bb-action-dropdown dropdown heroes-warehouse-dropdown" *ngIf="isAdmin">
        <button
          class="bb-btn bb-btn-secondary dropdown-toggle"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <i class="fa-solid fa-warehouse" aria-hidden="true"></i>
          <span>
            {{ selectedWarehouseName || ("Pospage" | transloco) }}
          </span>
        </button>

        <ul class="bb-dropdown-menu dropdown-menu">
          <li *ngFor="let el of allWareHouses">
            <a
              class="bb-dropdown-item dropdown-item"
              (click)="applyWareHouse(el.id)"
            >
              {{ el.name }}
            </a>
          </li>
        </ul>
      </div>
      -->
    </section>

    <!-- Empty State -->
    <section class="heroes-empty-state" *ngIf="noData && !contentReady">
      <div class="heroes-empty-icon">
        <i class="fa-solid fa-truck-fast" aria-hidden="true"></i>
      </div>

      <h3>{{ "No Data Found" | transloco }}</h3>
      <p>{{ "There are no delivery heroes yet" | transloco }}</p>
    </section>

    <!-- Cards -->
    <section class="heroes-ticket-list" *ngIf="!noData">
      <article
        class="hero-ticket"
        *ngFor="let element of allData; trackBy: trackByHeroId"
      >

        <!-- Top -->
        <div class="hero-ticket-top">

          <div class="hero-main-info">
            <div class="hero-avatar">
              <img
                *ngIf="getHeroImage(element)"
                [src]="getHeroImage(element)"
                [alt]="element.name || 'delivery hero'"
              />

              <span *ngIf="!getHeroImage(element)">
                {{ getInitial(element.name) }}
              </span>
            </div>

            <div class="hero-copy">
              <span>
                {{ "delivery heroes" | transloco }}
              </span>

              <h3>
                {{ element.name || "-" }}
              </h3>

              <div class="hero-method-badge" *ngIf="element.method">
                <i class="fa-solid fa-motorcycle" aria-hidden="true"></i>
                {{ element.method }}
              </div>
            </div>
          </div>

          <!-- Dropdown -->
          <div class="bb-action-dropdown dropdown hero-ticket-menu">
            <button
              class="bb-icon-btn"
              type="button"
              data-bs-toggle="dropdown"
              data-bs-boundary="viewport"
              aria-expanded="false"
              [attr.aria-label]="'Actions' | transloco"
            >
              <i class="fa-solid fa-ellipsis-vertical" aria-hidden="true"></i>
            </button>

            <ul class="bb-dropdown-menu dropdown-menu dropdown-menu-end">
              <li>
                <a
                  class="bb-dropdown-item dropdown-item text-danger"
                  (click)="deleteitem(element.id)"
                >
                  <i class="fa-solid fa-trash" aria-hidden="true"></i>
                  {{ "Delete" | transloco }}
                </a>
              </li>
            </ul>
          </div>

        </div>

        <!-- Details -->
        <div class="hero-ticket-details">

          <div class="hero-detail-chip">
            <i class="fa-solid fa-phone" aria-hidden="true"></i>

            <span>
              {{ "phone" | transloco }}
            </span>

            <strong>
              {{ element.phone || "-" }}
            </strong>
          </div>

          <div class="hero-detail-chip">
            <i class="fa-solid fa-image-portrait" aria-hidden="true"></i>

            <span>
              {{ "grov_id" | transloco }}
            </span>

            <strong>
              {{ element.national_id || "-" }}
            </strong>
          </div>

          <div class="hero-detail-chip hero-detail-wide" *ngIf="element.method">
            <i class="fa-solid fa-motorcycle" aria-hidden="true"></i>

            <span>
              {{ "delivery method" | transloco }}
            </span>

            <strong>
              {{ element.method }}
            </strong>
          </div>

        </div>

        <!-- Social Links -->
        <div
          class="hero-social-actions"
          *ngIf="element.instagram_link || element.facebook_link || element.tiktok_link"
        >
          <button
            *ngIf="element.instagram_link"
            type="button"
            class="hero-social-btn instagram"
            (click)="go(element.instagram_link)"
            [attr.aria-label]="'instagram' | transloco"
          >
            <i class="fa-brands fa-instagram" aria-hidden="true"></i>
          </button>

          <button
            *ngIf="element.facebook_link"
            type="button"
            class="hero-social-btn facebook"
            (click)="go(element.facebook_link)"
            [attr.aria-label]="'facebook' | transloco"
          >
            <i class="fa-brands fa-facebook-f" aria-hidden="true"></i>
          </button>

          <button
            *ngIf="element.tiktok_link"
            type="button"
            class="hero-social-btn tiktok"
            (click)="go(element.tiktok_link)"
            [attr.aria-label]="'tiktok' | transloco"
          >
            <i class="fa-brands fa-tiktok" aria-hidden="true"></i>
          </button>
        </div>

      </article>
    </section>

    <!-- Load More -->
    <div class="heroes-load-more-wrapper" *ngIf="canLoadMore && !contentReady">
      <button
        type="button"
        class="bb-btn bb-btn-secondary heroes-load-more-btn"
        [disabled]="loadingMore"
        (click)="loadMore()"
      >
        <span *ngIf="!loadingMore">
          {{ "see more" | transloco }}
        </span>

        <span *ngIf="loadingMore">
          {{ "loading" | transloco }}...
        </span>
      </button>
    </div>

  </div>
</section>